module.exports = __webpack_public_path__ + "img/dai1.fa5fb09b.png";